import axios from "axios";
import "./Dashboard.css";
//import notificationSound from "./assets/notification.mp3";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const [activeSection, setActiveSection] = useState("Order");
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [orders, setOrders] = useState([]);
  const [products, setProducts] = useState([]);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [prevOrderIds, setPrevOrderIds] = useState(new Set());
  const [selectedDate, setSelectedDate] = useState("");
  const [productSearch, setProductSearch] = useState("");
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [autoRefresh, setAutoRefresh] = useState(true);
  const [refreshInterval, setRefreshInterval] = useState(10);

  const intervalRef = useRef(null);

  const handleUserInteraction = () => {
    if (!hasInteracted) {
      setHasInteracted(true);
    } 
  };

  const login_branchName = localStorage.getItem("branch_name");

   console.log(`login_branchName: ${login_branchName}`);
  const fetchOrders = () => {
    console.log("Fetching orders..."); // Add this
    axios
      .get("https://agaram.ematixsolutions.com/api/orders")
      .then((response) => {
        const allOrders = response.data.orders || [];
        console.log(allOrders); // Add this
        const branchId = localStorage.getItem("branch_id");
        console.log("branchId"); // Add this
        console.log(branchId); // Add this

        const filteredOrders = allOrders.filter(
          (order) => String(order.branch_id) === String(branchId)
        );
        setOrders(filteredOrders);

        const newOrderIds = new Set(filteredOrders.map((order) => order.id));
        const diff = [...newOrderIds].filter((id) => !prevOrderIds.has(id));
        if (diff.length > 0 && hasInteracted) {
          alert(`🔔 New order${diff.length > 1 ? "s" : ""} received!`);
        }
        setPrevOrderIds(newOrderIds);
      })
      .catch((error) => console.error("Error fetching orders:", error));
  };

  useEffect(() => {
    if (activeSection === "Category") {
      axios
        .get("https://agaram.ematixsolutions.com/api/categories")
        .then((response) => setCategories(response.data))
        .catch((error) => console.error("Error fetching categories:", error));
    } else if (activeSection === "Subcategory") {
      axios
        .get("https://agaram.ematixsolutions.com/api/subcategories")
        .then((response) => setSubcategories(response.data))
        .catch((error) =>
          console.error("Error fetching subcategories:", error)
        );
    } else if (activeSection === "Order") {
      fetchOrders();
      if (autoRefresh) {
        clearInterval(intervalRef.current);
        intervalRef.current = setInterval(fetchOrders, refreshInterval * 1000);
        return () => clearInterval(intervalRef.current);
      }
    } else if (activeSection === "Product") {
      axios
        .get("https://agaram.ematixsolutions.com/api/products")
        .then((response) => setProducts(response.data.products))
        .catch((error) => console.error("Error fetching products:", error));
    }
  }, [activeSection, autoRefresh, refreshInterval]);

  const deleteProduct = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this product?"
    );
    if (!confirmDelete) return;

    try {
      await fetch(`https://agaram.ematixsolutions.com/api/products/${id}`, {
        method: "DELETE",
      });
      alert("Product deleted successfully.");
      // Refresh products
      axios
        .get("https://agaram.ematixsolutions.com/api/products")
        .then((response) => setProducts(response.data.products))
        .catch((error) => console.error("Error fetching products:", error));
    } catch (error) {
      console.error("Failed to delete product:", error);
      alert("Failed to delete product.");
    }
  };

  const deleteSubcategory = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this subcategory?"
    );
    if (!confirmDelete) return;

    try {
      await fetch(`https://agaram.ematixsolutions.com/api/subcategories/${id}`, {
        method: "DELETE",
      });
      alert("Subcategory deleted successfully.");
      // Refresh the subcategory list
      axios
        .get("https://agaram.ematixsolutions.com/api/subcategories")
        .then((response) => setSubcategories(response.data))
        .catch((error) =>
          console.error("Error fetching subcategories:", error)
        );
    } catch (error) {
      console.error("Failed to delete subcategory:", error);
      alert("Failed to delete subcategory.");
    }
  };

  // New function to update order status via API
  const updateOrderStatus = async (orderId, newStatus) => {
    try {
      await axios.put(`https://agaram.ematixsolutions.com/api/orders/${orderId}/status`, {
        status: newStatus,
      });
      alert(`Order ${orderId} status updated to ${newStatus}`);
      fetchOrders();
    } catch (error) {
      console.error("Error updating order status:", error);
      alert("Failed to update order status.");
    }
  };

  const filteredOrders = orders.filter((order) => {
    const matchDate =
      !selectedDate ||
      new Date(order.created_at).toISOString().slice(0, 10) === selectedDate;
    const search = searchText.toLowerCase();

    const matchSearch =
      !searchText ||
      order.user_name?.toLowerCase().includes(search) ||
      order.mobile?.toLowerCase().includes(search) ||
      order.custom_order_id?.toString().toLowerCase().includes(search) ||
      order.id?.toString().toLowerCase().includes(search);

    return matchDate && matchSearch;
  });

  const deleteCategory = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this category?"
    );
    if (!confirmDelete) return;

    try {
      await fetch(`https://agaram.ematixsolutions.com/api/categories/${id}`, {
        method: "DELETE",
      });

      // Refresh category list after deletion
      const response = await fetch("https://agaram.ematixsolutions.com/api/categories");
      const data = await response.json();
      setCategories(data);

      alert("Category deleted successfully.");
    } catch (error) {
      console.error("Error deleting category:", error);
      alert("Failed to delete category.");
    }
  };
  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const renderSection = () => {
    switch (activeSection) {
      case "Order":
        return (
          <div>
            <h2>Orders</h2>
            <label>🔄 Auto-refresh: </label>
            <input
              type="checkbox"
              checked={autoRefresh}
              onChange={(e) => setAutoRefresh(e.target.checked)}
            />
            <label style={{ marginLeft: "10px" }}>Interval (sec): </label>
            <input
              type="number"
              value={refreshInterval}
              onChange={(e) => setRefreshInterval(Number(e.target.value))}
              min="5"
              max="60"
            />

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "1rem",
                marginTop: "1rem",
              }}
            >
              <input
                type="text"
                placeholder="Search by name, order ID or mobile"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{
                  padding: "10px 14px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  fontSize: "14px",
                  width: "100%",
                  maxWidth: "250px",
                  outline: "none",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                  transition: "border 0.2s ease-in-out",
                }}
                onFocus={(e) => (e.target.style.border = "1px solid #007bff")}
                onBlur={(e) => (e.target.style.border = "1px solid #ccc")}
              />

              <input
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                style={{
                  padding: "10px 14px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  fontSize: "14px",
                  backgroundColor: "#fff",
                  color: "#333",
                  outline: "none",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                  transition: "border 0.2s ease-in-out",
                  cursor: "pointer",
                  maxWidth: "200px",
                  width: "100%",
                }}
                onFocus={(e) => (e.target.style.border = "1px solid #007bff")}
                onBlur={(e) => (e.target.style.border = "1px solid #ccc")}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "1rem",
                marginTop: "1rem",
              }}
            ></div>
            <div className="order-table-wrapper">
              <table className="category-table">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>User</th>
                    <th>Mobile</th>
                    <th>Total Amount</th>
                    {/* <th>Total Amount</th> */}
                    <th>Remarks</th>
                    <th>Time</th>
                    <th>Address</th>
                    <th>Order Date</th>
                    <th>Items</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredOrders.map((order) => (
                    <tr
                      key={order.id}
                      onClick={() => navigate(`/orders/${order.id}`)}
                      style={{ cursor: "pointer", backgroundColor: "#fff" }}
                    >
                      <td>{order.custom_order_id || order.id}</td>
                      <td>{order.user_name}</td>
                      <td>{order.mobile}</td>
                      <td>{order.total_amount}</td>
                      <td>{order.remarks}</td>
                      <td>{order.delivery_time}</td>
                      <td>{order.address}</td>
                      <td>{formatDateTime(order.created_at)}</td>

                      <td>
                        {order.items && order.items.length > 0 ? (
                          <ul>
                            {order.items.slice(0, 3).map((item) => (
                              <li key={item.id}>
                                {item.product_name} - Qty: {item.quantity} -
                                Code: {item.product_code}, Price: ₹{item.price}
                              </li>
                            ))}
                            {order.items.length > 3 && (
                              <li
                                style={{ fontStyle: "italic", color: "#777" }}
                              >
                                + {order.items.length - 3} more…
                              </li>
                            )}
                          </ul>
                        ) : (
                          <span>No items</span>
                        )}
                      </td>

                      <td>
                        <select
                          value={order.status || ""}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) =>
                            updateOrderStatus(order.id, e.target.value)
                          }
                        >
                          <option value="">Select Status</option>
                          <option value="Confirmed">Confirmed</option>
                          <option value="Packed">Packed</option>
                          <option value="On the Way">On the Way</option>
                          <option value="Delivered">Delivered</option>
                        </select>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
     case "Category":
  return (
    <div>
      <h2
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Category
        <button
          onClick={() => (window.location.href = "/add-category")}
          className="action-btn"
        >
          + Add Category
        </button>
      </h2>

      <table className="category-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((cat) => (
            <tr key={cat.id}>
              <td>{cat.id}</td>
              <td>{cat.name}</td>
              <td>
               {cat.image ? (
  <img
     src={`https://agaram.ematixsolutions.com/public/${encodeURIComponent(cat.image)}`}
    alt={cat.name}
    width="60"
    height="60"
  />
) : (
  "No image"
)}

              </td>
              <td>
                <button
                  className="action-btn edit-btn"
                  onClick={() =>
                    (window.location.href = `/edit-category/${cat.id}`)
                  }
                >
                  Edit
                </button>
                <button
                  className="action-btn delete-btn"
                  onClick={() => deleteCategory(cat.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

      case "Subcategory":
        return (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h2>Subcategory</h2>
              <button
                onClick={() => (window.location.href = "/add-subcategory")}
                className="action-btn"
              >
                + Add Subcategory
              </button>
            </div>

            <table className="category-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Image</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {subcategories.map((sub) => (
                  <tr key={sub.id}>
                    <td>{sub.id}</td>
                    <td>{sub.name}</td>
                    <td>{sub.category?.name || "N/A"}</td>
                    <td>
                      {sub.image ? (
                        <img
                           src={`https://agaram.ematixsolutions.com/public/${encodeURIComponent(sub.image)}`}
                          alt={sub.name}
                          width="60"
                          height="60"
                        />
                      ) : (
                        "No image"
                      )}
                    </td>
                    <td>
                      <button
                        className="action-btn edit-btn"
                        onClick={() =>
                          (window.location.href = `/edit-subcategory/${sub.id}`)
                        }
                      >
                        Edit
                      </button>
                      <button
                        className="action-btn delete-btn"
                        onClick={() => deleteSubcategory(sub.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      case "Product":
        const branchId = localStorage.getItem("branch_id");

        const filteredProducts = products.filter((product) => {
          const search = productSearch.toLowerCase();

          return (
            product.name.toLowerCase().includes(search) ||
            product.subcategory?.name.toLowerCase().includes(search) ||
            product.code?.toLowerCase().includes(search) ||
            product.variants?.some(
              (variant) =>
                variant.size?.toLowerCase().includes(search) ||
                variant.unit?.toLowerCase().includes(search)
            )
          );
        });

        return (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
              }}
            >
              <button
                onClick={() => navigate("/productupload")}
                className="action-btn"
              >
                Excel Sheet Upload
              </button>
              <h2>Products</h2>
              <button
                onClick={() => navigate("/add-product")}
                className="action-btn"
              >
                + Add Product
              </button>
            </div>

            <input
              type="text"
              placeholder="Search by name,subcategory,code"
              value={productSearch}
              onChange={(e) => setProductSearch(e.target.value)}
              style={{
                marginBottom: "16px",
                padding: "10px 14px",
                width: "100%",
                maxWidth: "400px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                fontSize: "16px",
                outline: "none",
                boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                transition: "border-color 0.2s, box-shadow 0.2s",
              }}
              onFocus={(e) =>
                (e.target.style.borderColor = "#007bff") &&
                (e.target.style.boxShadow = "0 0 0 3px rgba(0,123,255,0.2)")
              }
              onBlur={(e) =>
                (e.target.style.borderColor = "#ccc") &&
                (e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.05)")
              }
            />

            <table className="category-table">
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Product Code</th>
                  <th>Subcategory</th>
                  <th>Size</th>
                  <th>MRP (₹)</th>
                  <th>Rate (₹)</th>
                  <th>Branch</th>
                  <th>Stock</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredProducts
                  .flatMap((product) =>
                    product.variants.flatMap((variant) =>
                      variant.stocks
                        .filter(
                          (stock) =>
                            String(stock.branch?.id) === String(branchId)
                        )
                        .map((stock) => ({
                          product,
                          variant,
                          stock,
                        }))
                    )
                  )
                  .sort((a, b) => a.stock.stock - b.stock.stock) // <-- sort by stock ascending
                  .map(({ product, variant, stock }) => (
                    <tr key={`${product.id}-${variant.id}-${stock.id}`}>
                      <td>{product.name}</td>
                      <td>{product.code}</td>
                      <td>{product.subcategory?.name || "N/A"}</td>
                      <td>{variant.size}</td>
                      <td>₹{variant.mrp}</td>
                      <td>₹{variant.rate}</td>
                      <td>{stock.branch?.name}</td>
                      <td>
                        {stock.stock}
                        {stock.stock < 10 && (
                          <span
                            style={{
                              color: "red",
                              fontSize: "12px",
                              marginLeft: "8px",
                            }}
                          >
                            ⚠ Low Stock
                          </span>
                        )}
                      </td>

                      <td>
                        <button
                          className="action-btn edit-btn"
                          onClick={() =>
                            navigate(`/edit-product/${product.id}`)
                          }
                        >
                          Edit
                        </button>

                        <button
                          className="action-btn delete-btn"
                          onClick={() => deleteProduct(product.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        );
      default:
        return <h2>Welcome</h2>;
    }
  };

  return (
    <div className="dashboard-container" onClick={handleUserInteraction}>
      <aside className="sidebar">
       <div style={{ padding: "1rem", textAlign: "center", color: "#fff" }}>
        <h1 style={{ marginBottom: "0.2rem" }}>{login_branchName}</h1>
        <h2 className="sidebar-title">Admin Panel</h2>
      </div>
        <nav className="nav-links">
          {["Order", "Category", "Subcategory", "Product"].map((item) => (
            <div
              key={item}
              className={`nav-item ${activeSection === item ? "active" : ""}`}
              onClick={() => setActiveSection(item)}
            >
              {item}
            </div>
          ))}
        </nav>
      </aside>
      <main className="main-content">{renderSection()}</main>

      {/* <audio ref={audioRef} src={notificationSound} preload="auto" /> */}
    </div>
  );
}

export default Dashboard;
